module.exports = __webpack_public_path__ + "img/23.17e155e6.png";